export default "__VITE_PUBLIC_ASSET__3d3be6e3__"